/**
 * @file routes/navigator.ts
 * @description abstraction  to manage the useHistory to useNavigator upgrades
 *   provides all the routes navigation services
 *
 * @author ogarcia (ozkary)
 *
 */
import { useCallback } from 'react';
import {
    Location, NavigateFunction, useLocation, useNavigate
} from 'react-router';
import { NavigateOptions } from 'react-router-dom';

 
/**
 * callback type for the location changes
 */
// type listener = () => void;

/**
 * Navigator class to abstract the useNavigate and useLocation React functions
 * Include other routing dependencies here
 */
class Navigator {
  // private constructor to prevent instantiation
  private constructor() {}

  // static instances to use by the app
  public static navInstance: NavigateFunction;
  public static locInstance: Location;     
}

/**
 * navigation operations
 */
export interface HistoryOps {
  // use push route '/route'
  push: (path: string, options?: NavigateOptions) => void;
  // or delta change go operations for back -1 or forward 1
  go: (path: number) => void;
  // route location
  location: Location;
  // listen to location changes
  // listen (callback: listener) : void;
}

/**
 * Returns the navigator instance for navigation and location information
 * Backward compatibility with React version updates
 * @returns the navigator reference
 */
export const useHistory = (): HistoryOps => {
  const navigate = useNavigate();

  /**
   * Returns the navigator instance
   * @returns the navigate instance
   */
  //  const getNavInstance = (): NavigateFunction => {
  //   if (!Navigator.navInstance) {
  //     Navigator.navInstance = useNavigate();
  //   }
  //   return Navigator.navInstance;
  // }

  /**
   * Hook to track location changes
   * @param callback action when the location changes
   */
  //  const listenEffect = (callback: listener) : void => {
  //   const location = getLocInstance();
  //   useEffect(() => {
  //         callback();
  //   }, [location, callback]);
  // };
   
  /**
   * Returns the location instance
   * @returns the location reference
   */
   const getLocInstance = (): Location => {
    if (!Navigator.locInstance) {
      Navigator.locInstance = useLocation();
    }
    return Navigator.locInstance;
  }

  const push = useCallback((path: string, options?: NavigateOptions) => {
    navigate(path, options);
  }, []);

  const go = useCallback((path: number) => {
    navigate(path);
  }, []);
  const location = getLocInstance();
  // const listen = listenEffect;

  return {
    push: push,
    go: go,
    location: location
  };
};
